import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(
  <path d="M6 22C5.44772 22 5 21.5523 5 21V3C5 2.44772 5.44772 2 6 2H12C14.7894 2 17 4.48695 17 7.5C17 8.96403 16.4781 10.3038 15.6215 11.2945C17.5995 12.0369 19 14.1018 19 16.5C19 19.4377 16.8985 21.8753 14.2081 21.9954L14 22H6ZM14.1675 13.0055L14 13H7V20H14C15.6289 20 17 18.4575 17 16.5C17 14.61 15.7218 13.1069 14.1675 13.0055ZM12 4H7V11H12C13.6289 11 15 9.45752 15 7.5C15 5.60998 13.7218 4.10687 12.1675 4.00546L12 4Z" />,
  'FormatBold'
);
